export const LogoMark = ({ className = "w-8 h-8", dark = true }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill={dark ? "#281715" : "#FAF7F2"} />
    <circle cx="32" cy="32" r="19" fill="none" stroke="#EBB1B6" strokeWidth="3" />
    <path d="M32 16c6 9 9 14 9 19a9 9 0 0 1-18 0c0-5 3-10 9-19z" fill={dark ? "#FAF7F2" : "#281715"} />
    <ellipse cx="28.5" cy="34" rx="2" ry="3.4" fill="#EBB1B6" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark className="w-8 h-8" dark={!light} />
    <span className={`font-display text-xl tracking-[0.28em] ${light ? "text-[#FAF7F2]" : "text-[#281715]"}`}>
      LUMI
    </span>
  </span>
);
